/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react"
import { Box, Container, Stack } from "@mui/material"

function AppLogoutContainer(props: { children: React.ReactNode }) {
  return (
    <Stack height="100%">
      <Box
        flexGrow={1}
        sx={{ backgroundColor: "#ECF0F4" }}
        display="flex"
        alignItems="center"
        padding="30px"
      >
        <Container>{props.children}</Container>
      </Box>
    </Stack>
  )
}

export default AppLogoutContainer
